import { ColDef } from '@ag-grid-enterprise/all-modules'
import { ICellRendererParams } from '@ag-grid-community/core/dist/cjs/rendering/cellRenderers/iCellRenderer'
import { AgGridColumnType, AgGridExportType, ExportedColDef, ExportedColGroupDef } from '@/shared/models/ag-grid.model'
import i18n from '@/lang/i18n'
import buildIconHeaderTemplate from '@/grid/buildIconHeaderTemplate'

export const laboratoryGridSamplesColumnDefs: (ColDef | ExportedColDef | ExportedColGroupDef)[] = [
    { type: AgGridColumnType.CUSTOM_CHECKBOX },
    {
        headerName: i18n.tc('laboratory.grid.columns.caseNumber'),
        field: 'caseStudy.casCasenumber',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        hide: true,
        width: 110
    },
    {
        headerName: i18n.tc('laboratory.grid.columns.sampleNumber'),
        colId: 'samLabel',
        field: 'sampleLabel',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        hide: true,
        width: 130
    },
    {
        headerName: i18n.tc('laboratory.grid.columns.location'),
        field: 'topographicCode.description',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        width: 135
    },
    {
        headerName: i18n.tc('laboratory.grid.columns.sampleType'),
        field: 'sampleType.description',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        width: 110
    },
    {
        headerName: i18n.tc('laboratory.grid.columns.registryDate'),
        colId: 'caseStudy.casRegistrationDate',
        field: 'caseStudy.registrationDate',
        type: AgGridColumnType.DATETIME,
        exportType: AgGridExportType.DATETIME,
        width: 110
    },
    {
        headerName: i18n.tc('laboratory.grid.columns.priority'),
        colId: 'caseStudy.priority.level',
        field: 'caseStudy.priority',
        type: AgGridColumnType.PRIORITY,
        exportField: 'caseStudy.priority.name',
        exportType: AgGridExportType.TEXT
    },
    {
        headerName: i18n.tc('laboratory.cytology.processingDate'),
        field: 'lastGrossingDate',
        type: AgGridColumnType.DATETIME,
        exportType: AgGridExportType.DATETIME,
        width: 150
    },
    {
        headerName: i18n.tc('laboratory.grid.columns.samplingDate'),
        colId: 'samSamplingDate',
        field: 'samplingDate',
        type: AgGridColumnType.DATETIME,
        exportType: AgGridExportType.DATETIME,
        width: 150
    },
    {
        headerName: i18n.tc('laboratory.grid.columns.processingResponsible'),
        colId: 'grossingResponsible.normalizedFullName',
        field: 'grossingResponsible.fullName',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        width: 150
    },
    {
        headerName: i18n.tc('laboratory.grid.processingStartPersonnel'),
        colId: 'processingStartPersonnel.normalizedFullName',
        field: 'processingStartPersonnel.fullName',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        width: 150
    },
    {
        headerName: i18n.tc('laboratory.grid.processingEndPersonnel'),
        colId: 'processingEndPersonnel.normalizedFullName',
        field: 'processingEndPersonnel.fullName',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        width: 150
    },
    {
        headerName: i18n.tc('laboratory.grid.processorControllerTechnician'),
        colId: 'grossingTech.normalizedFullName',
        field: 'grossingTechController.fullName',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        width: 150
    },
    {
        headerName: i18n.tc('laboratory.grid.processingStartDate'),
        field: 'processingStartDate',
        type: AgGridColumnType.DATETIME,
        exportType: AgGridExportType.DATETIME,
        width: 150
    },
    {
        headerName: i18n.tc('laboratory.grid.processingEndDate'),
        field: 'processingEndDate',
        type: AgGridColumnType.DATETIME,
        exportType: AgGridExportType.DATETIME,
        width: 150
    },
    {
        headerName: i18n.tc('laboratory.grid.specialist'),
        colId: 'specialist.normalizedFullName',
        field: 'specialist.fullName',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        width: 150
    },
    {
        headerName: i18n.tc('laboratory.grid.pathologist'),
        colId: 'caseStudy.pathologist.normalizedFullName',
        field: 'caseStudy.pathologist.fullName',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        width: 150
    },
    {
        headerName: i18n.tc('laboratory.grid.cytologyCoordinator'),
        colId: 'grossingCoor.normalizedFullName',
        field: 'grossingCoordinator.fullName',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        width: 150
    },
    {
        headerName: i18n.tc('laboratory.grid.cytologyTutor'),
        colId: 'grossingTutor.normalizedFullName',
        field: 'grossingTutor.fullName',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        width: 150
    },
    {
        headerName: i18n.tc('laboratory.grid.columns.status'),
        field: 'status',
        type: AgGridColumnType.LABORATORY_SAMPLE_STATUS,
        exportField: 'status.name',
        exportType: AgGridExportType.TEXT,
        width: 150
    },
    {
        headerName: i18n.tc('grid.hasAlarms'),
        headerTooltip: i18n.tc('grid.hasAlarms'),
        field: 'incidentsCount',
        type: AgGridColumnType.INCIDENT,
        exportType: AgGridExportType.INTEGER,
        filter: false,
        width: 55,
        headerComponentParams: {
            template: buildIconHeaderTemplate('far fa-exclamation-triangle')
        }
    },
    {
        headerName: i18n.tc('grid.attachments'),
        headerTooltip: i18n.tc('grid.attachments'),
        field: 'attachmentsCount',
        type: AgGridColumnType.ATTACHMENT_COUNT,
        exportType: AgGridExportType.INTEGER,
        headerComponentParams: {
            template: buildIconHeaderTemplate('far fa-paperclip')
        }
    },
    {
        headerName: i18n.tc('registry.btn.consultation'),
        headerTooltip: i18n.tc('registry.btn.consultation'),
        field: 'caseStudy.caseOfReference',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.BOOLEAN,
        filter: false,
        hide: false,
        width: 55,
        headerComponentParams: {
            template: buildIconHeaderTemplate('far fa-glasses')
        },
        cellRenderer: ({ value }: ICellRendererParams) => value === true ? '<i class="success far fa-check"/>' : ''
    }
]
